export default {
  LINECHART_CONTAINER: 'LINECHART_CONTAINER',
  LINECHART_CHART: 'LINECHART_CHART',
  LINECHARTWITHDOT_CONTAINER: 'LINECHARTWITHDOT_CONTAINER',
  LINECHARTWITHDOT_CHART: 'LINECHARTWITHDOT_CHART',
  LINEMETRICCHART_CONTAINER: 'LINEMETRICCHART_CONTAINER',
  LINEMETRICCHART_CHART: 'LINEMETRICCHART_CHART',
  VERTICALBAR_CONTAINER: 'VERTICALBAR_CONTAINER',
  VERTICALBAR_BAR: 'VERTICALBAR_BAR',
};
